export default __webpack_public_path__ + "static/media/1Sun.59c87999.svg";